import { UserRoleType } from '@/modules/user/types/user.enums'

export const getRoleName = (userRoleId?: number): string => {
  switch (userRoleId) {
    case UserRoleType.Admin:
      return 'Admin'
    case UserRoleType.Agent:
      return 'Agent'
    case UserRoleType.SuperUser:
      return 'Super user'
    case UserRoleType.SystemService:
      return 'Service user'
    case UserRoleType.User:
      return 'User'
    default:
      return ''
  }
}
